import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import React, { useEffect, useState } from 'react'
import { selectLandingPageDetails, selectPossibleSubjectModal, selectShowRelatedSubjectsModal, setShowRelatedSubjectsModal } from '../../redux/otherDetailsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { selectRelatedSkills } from '../../redux/multiSkillSelectionSlice'
import { skills } from '../../utilities/constants'
import { fetchPopularSkills, selectSearchResults } from '../../redux/searchSlice'
import SearchSkills from './SearchSkills'
import CloseModal from '../../components/CloseModal'
import CourseList from '../NewAnalysisPage/CourseList'
import NewSkillList from '../NewAnalysisPage/NewSkillList'
import useDebounce from '../../hooks/useDebounce'

const RelatedSubjectsModal = () => {

    const landingPage = useSelector(selectLandingPageDetails)
    const relatedSkills = useSelector(selectRelatedSkills)
    const searchResults = useSelector(selectSearchResults)
    const showRelatedSubjectsModal = useSelector(selectShowRelatedSubjectsModal)
    const possibleSubjectModal = useSelector(selectPossibleSubjectModal)

    const skill_name = landingPage?.skill_name
    const { subtitle } = possibleSubjectModal

    const [ showCategories, setShowCategories ] = useState(false)
    const [ showSkills, setShowSkills ] = useState(false)
    const [ searchParam, setSearchParam ] = useState('')
    const [ courseName, setCourseName ] = useState('')
    const [ skillList, setSkillList ] = useState([])

    const dispatch = useDispatch()

    const { debouncedValue } = useDebounce(searchParam, 300)

    useEffect(() => {
        if(debouncedValue){
            dispatch(fetchPopularSkills({ searchValue: debouncedValue }))
        }
    }, [debouncedValue, dispatch])

    const handleBack = () => {
        if (showSkills){
            setShowSkills(false)
        }else if (showCategories){
            setShowCategories(false)
        }
    }

    const handleModal = () => {
        dispatch(setShowRelatedSubjectsModal(false))
    }

    const handleCourseSelection = (item, index) => {
        setCourseName(item?.name)
        setShowSkills(true)

        setSkillList(() => {
            return skills[index]?.map((item) => item?.skill_name)
        })
    }
    
    return (
        <div>
            <Dialog
                open={showRelatedSubjectsModal}
                onClose={handleModal}
                as='div'
                className="fixed z-40 inset-0 flex flex-col mx-auto text-white"
            >
                <Dialog.Overlay className="fixed inset-0 mx-auto z-50 bg-black opacity-80" />
                <Dialog.Title/>
                <Dialog.Description/>
                <div className='p-[1px] bg-glass-effect m-auto max-w-2xl rounded-2xl w-[90%] z-[80] shadow-[0_0_20px_rgba(0, 0, 0, 0.3)]'>
                    <div className='p-3 bg-modal-bg max-h-[562px] flex flex-col rounded-2xl relative text-[#B0C1CD] overflow-y-scroll'>
                        {!showCategories && <>
                            <div className='flex justify-between gap-3 leading-[130%]'>
                                <div className=''>
                                    <h2 className='text-white text-xl flex-1 font-bold'>View All Available Subjects</h2>
                                    <p className='text-sm leading-[130%] mt-2'>{subtitle}</p>
                                </div>
                                <div className='cursor-pointer flex-shrink-0 h-fit' onClick={handleModal}>
                                    <img src="https://assets.learntube.ai/files/New%20Analysis%20Page/Close.svg?updatedAt=1742903383647" width={25} height={25} alt="" />
                                </div>
                            </div>
                            <div className='flex flex-col mt-6 flex-1'>
                                <h3 className='text-white text-sm font-semibold mb-3'>Related to <span className='text-span_color'>{skill_name}</span></h3>
                                <div className='max-h-[184px] overflow-y-scroll flex flex-wrap gap-2 pr-1 bundle'>
                                    {relatedSkills?.map((item, index) => (
                                        <div key={index} className='bg-bg-13/[15%] text-border h-fit text-xs p-2 rounded-lg'>
                                            {item}
                                        </div>
                                    ))}
                                </div>
                                <div className='mt-6'>
                                    <h4 className='font-medium text-white'>Couldn’t find what you’re looking for?</h4>
                                    <div className='my-3'>
                                        <SearchSkills
                                            skillName={searchParam}
                                            setSkillName={setSearchParam}
                                        />
                                    </div>
                                    {searchParam && searchResults?.length > 0 ? <div className='max-h-[184px] overflow-y-scroll flex gap-2 flex-wrap bundle pr-1'>
                                        {searchResults.map((item, index) => (
                                        <div key={index} className='bg-bg-13/[15%] text-border h-fit text-xs p-2 rounded-lg'>
                                            <p className=''>{item}</p>
                                        </div>))}
                                    </div> : searchParam && searchResults?.length === 0 ? <div className='bg-bg-13/[15%] text-border h-fit text-xs p-2 rounded-lg'>
                                            <p className=''>{searchParam}</p>
                                        </div> : null}
                                    <p className='text-xs text-[#97BDE3] text-center mt-3 underline' onClick={() => setShowCategories(true)}>Or Explore by Category</p>
                                </div>
                            </div>
                        </>}
                        {showCategories && <div className='overflow-y-scroll w-full text-white'>
                            <div className='flex gap-2 items-center'>
                                <FontAwesomeIcon icon={faChevronLeft} className='text-xl' onClick={handleBack}/>
                                <h3 className='flex-1 text-xl text-white font-bold'>Explore More Certificates</h3>
                                <CloseModal handleModal={handleModal} />
                            </div>
                            <div className='my-4'>
                                <SearchSkills
                                    skillName={searchParam}
                                    setSkillName={setSearchParam}
                                />
                            </div>
                            <h3 className='font-medium'>{debouncedValue ? 'Search Results' : showSkills ? <span><FontAwesomeIcon icon={faChevronLeft} className='mr-2 text-xl -mb-0.5' onClick={() => setShowSkills(false)} />{courseName}</span> : 'Categories'}</h3>
                            {debouncedValue ? <NewSkillList
                                skills={searchResults}
                            /> : !showSkills ? <CourseList
                                handleCourseSelection={handleCourseSelection}
                            /> : <NewSkillList
                                skills={skillList}
                            />}
                        </div>}
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default RelatedSubjectsModal